import { cyan, informationL1, midGray, primaryBlack, white } from 'shared/theme/colors'
import { label2 } from 'shared/theme/typography'
import styled from 'styled-components'

export const AutocompleteContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 424px;
  min-width: 101px;

  > div:first-child {
    margin-bottom: 8px;
  }
`

export const Options = styled.div`
  position: absolute;
  top: 56px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 250px;
  overflow-y: scroll;
  background: ${white};
  z-index: 11;
  border: 1px solid ${cyan};
  border-radius: 3px;
`

export const Option = styled.label<{ $isFocused?: boolean }>`
  ${label2};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  color: ${midGray};
  text-align: left;

  &:hover,
  &:focus,
  &:focus-within {
    background: ${informationL1};
    cursor: pointer;
    color: ${primaryBlack};
  }

  ${(p) =>
    p.$isFocused &&
    `
    background: ${informationL1};
    cursor: pointer;
    color: ${primaryBlack};
  `}
`
